import { ServiceBase } from '../../../../../../../core/services/ServiceBase'
import ImportExportProxy from './proxy'

class ImportExportService extends ServiceBase {
  getImportExportData(params) {
    return this.getData(() => ImportExportProxy.getImportExportData(params))
  }
}

export default new ImportExportService()
